// extracted by mini-css-extract-plugin
export default {"cta":"PromoCodeCtaText-rebranding-module__cta___1WIKY"};